import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'Task',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Task',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Task',
    column_type: 'datetime',
  },
  creator: {
    model_name: 'Task',
    column_type: 'belongs_to',
    extra: {
      association_name: 'creator',
      model_name: 'User',
    },
  },
  creator_id: {
    model_name: 'Task',
    column_type: 'belongs_to',
    extra: {
      association_name: 'creator',
      model_name: 'User',
    },
  },
  title: {
    model_name: 'Task',
    column_type: 'string',
  },
  content: {
    model_name: 'Task',
    column_type: 'text',
  },
  filters: {
    model_name: 'Task',
    column_type: 'string',
  },
  display_filters: {
    model_name: 'Task',
    column_type: 'string',
  },
  task_assignments: {
    model_name: 'Task',
    column_type: 'has_many',
    extra: {
      association_name: 'task_assignments',
      model_name: 'TaskAssignment',
      foreign_key: 'task_id',
    },
  },
  task_assignment_ids: {
    model_name: 'Task',
    column_type: 'has_many',
    extra: {
      association_name: 'task_assignments',
      model_name: 'TaskAssignment',
      foreign_key: 'task_id',
    },
  },
  assignees: {
    model_name: 'Task',
    column_type: 'has_many',
    extra: {
      association_name: 'assignees',
      model_name: 'User',
      foreign_key: 'assignee_id',
    },
  },
  assignee_ids: {
    model_name: 'Task',
    column_type: 'has_many',
    extra: {
      association_name: 'assignees',
      model_name: 'User',
      foreign_key: 'assignee_id',
    },
  },
  customers_count: {
    model_name: 'Task',
    column_type: 'string',
  },
  followed_customers_count: {
    model_name: 'Task',
    column_type: 'string',
  },
  follow_ratio: {
    model_name: 'Task',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
